function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgrammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 19,
    r: 1,
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 19,
    r: 1,
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.895 21.553-1.789.895.105.211c.722 1.444 2.174 2.341 3.789 2.341s3.067-.897 3.789-2.342l.105-.211-1.789-.895-.105.212c-.381.762-1.147 1.236-2 1.236s-1.619-.474-2-1.236z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 48h6v-8h-6zm2-6h2v4h-2z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 40h2v8h-2z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 30h-6v8h6zm-2 6h-2v-4h2z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 30h2v8h-2z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63 21c0-8.822-7.178-16-16-16-1.834 0-3.619.324-5.327.928-2.185-2.981-5.702-4.928-9.673-4.928-4.831 0-8.994 2.876-10.895 7h-18.105c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h6.5l2.3 3.066c.438.585 1.136.934 1.867.934 1.286 0 2.333-1.047 2.333-2.333v-1.667h4.031c.1 1.894.531 3.722 1.248 5.42-.818.279-1.577.667-2.279 1.137v-.557h-6v8h1.58l-1.389 6.946c-.127.634-.191 1.283-.191 1.929 0 3.52 1.898 6.79 4.954 8.536l1.254.717.475 3.563c.25 1.887 1.875 3.31 3.779 3.31h17.074c1.904 0 3.529-1.423 3.779-3.31l.475-3.563 1.254-.717c3.058-1.746 4.956-5.016 4.956-8.536 0-.646-.064-1.295-.191-1.929l-1.621-8.108c7.834-1.074 13.812-7.805 13.812-15.838zm-18.916 9h5.982c-.709 1.515-1.5 2.697-2.177 3.561-.925-1.505-2.23-2.741-3.805-3.561zm5.969-18h-6.104c1.068-2.285 2.314-3.816 3.051-4.6.739.786 1.984 2.322 3.053 4.6zm10.896 8h-6.986c-.089-2.259-.455-4.263-.987-6h6.13c1.039 1.789 1.689 3.825 1.843 6zm-8.986 0h-7.963v-6h6.858c.583 1.701 1.006 3.701 1.105 6zm-8.716 8c.488-1.545.753-3.176.753-4.849v-1.151h7.971c-.098 2.299-.522 4.3-1.102 6zm10.724-6h6.981c-.155 2.171-.808 4.207-1.848 6h-6.135c.536-1.74.913-3.742 1.002-6zm3.737-10h-5.457c-.859-2.062-1.886-3.648-2.76-4.765 3.275.591 6.157 2.317 8.217 4.765zm-13.183-4.773c-.388.498-.802 1.083-1.226 1.771-.162-.456-.35-.899-.563-1.327.587-.188 1.183-.336 1.789-.444zm-22.525 5.773c0-5.514 4.486-10 10-10s10 4.486 10 10v10.151c0 5.079-2.732 9.729-7.063 12.239-.113-.545-.381-1.032-.746-1.425 3.581-2.278 5.809-6.241 5.809-10.581v-8.384c0-4.411-3.589-8-8-8s-8 3.589-8 8v8.384c0 4.34 2.228 8.303 5.809 10.581-.366.394-.633.88-.746 1.425-4.331-2.51-7.063-7.16-7.063-12.239zm16 2.37c-1.192-1.033-2.612-1.784-4.166-2.188-.408-1.261-1.581-2.182-2.977-2.182-1.575 0-2.857 1.282-2.857 2.857v.143h2v-.143c0-.472.385-.857.857-.857.63 0 1.143.513 1.143 1.143 0 .556-.416 1.026-.968 1.096l-5.032.628v-.867c0-3.309 2.691-6 6-6s6 2.691 6 6zm-12 2.513 5.28-.66c1.163-.146 2.111-.927 2.513-1.967 1.696.546 3.166 1.618 4.207 3.071v2.673c0 3.309-2.691 6-6 6s-6-2.691-6-6zm10.41 11.066-.228-1.142c.423-.261.819-.559 1.186-.892-.254.711-.563 1.397-.958 2.034zm-8.591-1.142-.228 1.142c-.395-.637-.704-1.323-.957-2.034.365.333.762.631 1.185.892zm1.869.849c.733.222 1.508.344 2.312.344s1.579-.122 2.312-.344l.46 2.298c-.806.779-1.727 1.45-2.771 1.948-1.044-.499-1.966-1.169-2.771-1.948zm1.312 7.344c0-.502.378-.901.861-.972l.139.06.139-.06c.483.071.861.47.861.972v2c0 .552-.448 1-1 1s-1-.448-1-1zm-17-14v3.667c-.001.288-.429.43-.601.2l-2.899-3.867h-7.5v-12h17.395c-.249.961-.395 1.962-.395 3v.586l-2.293-2.293-1.414 1.414 3.293 3.293-3.293 3.293 1.414 1.414 2.293-2.293v3.586zm1 10h2v.339c-.896 1.051-1.568 2.29-1.96 3.661h-.04zm6.813 13h20.373c1 0 1.813.813 1.813 1.813 0 .08-.005.159-.016.24l-1.325 9.947h-21.316l-1.327-9.947c-.01-.08-.015-.159-.015-.24 0-1 .813-1.813 1.813-1.813zm18.724 16h-17.074c-.905 0-1.678-.676-1.797-1.573l-.057-.427h20.782l-.057.427c-.119.897-.892 1.573-1.797 1.573zm4.588-7.373.842-6.309c.022-.168.033-.337.033-.505 0-1.823-1.288-3.347-3-3.722v-2.856l.895-1.789-1.789-.895-1.106 2.213v3.236h-18v-3.236l-1.105-2.211-1.789.895.894 1.788v2.856c-1.712.374-3 1.899-3 3.722 0 .168.011.337.033.504l.842 6.31c-2.391-1.402-3.875-3.978-3.875-6.753 0-.515.052-1.031.152-1.536l1.635-8.178c.57-2.846 2.656-5.093 5.394-5.924 1.569 2.71 3.917 4.952 6.818 6.387v.376c0 1.654 1.346 3 3 3s3-1.346 3-3v-.376c2.902-1.435 5.25-3.677 6.818-6.387 2.738.831 4.825 3.078 5.394 5.924l1.635 8.178c.102.505.154 1.021.154 1.536 0 2.775-1.484 5.351-3.875 6.752zm4.356-18.856c.87-1.117 1.907-2.705 2.769-4.771h5.449c-2.058 2.445-4.93 4.182-8.218 4.771z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.293 11.293-4.707 4.707 4.707 4.707 1.414-1.414-3.293-3.293 3.293-3.293z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.877 15h8.246v1.999h-8.246z",
    transform: "matrix(.242 -.97 .97 .242 -5.673 24.736)",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammer);
export default __webpack_public_path__ + "static/media/programmer.b0d0d407.svg";
export { ForwardRef as ReactComponent };